/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamGridExamidQueryResponse,
  GetApiV1ExamGridExamidPathParams,
  GetApiV1ExamGridExamid400,
  GetApiV1ExamGridExamid401,
  GetApiV1ExamGridExamid500,
} from "../../types/examEvaluationController/GetApiV1ExamGridExamid.ts";

function getGetApiV1ExamGridExamidUrl(
  examId: GetApiV1ExamGridExamidPathParams["examId"],
) {
  const res = { method: "GET", url: `/api/v1/exam/grid/${examId}` as const };
  return res;
}

/**
 * @description Retorna a prova para exibição por id. **(Requer Authorization para autenticação)**
 * @summary Buscar prova por id (Requer Authorization para autenticação)
 * {@link /api/v1/exam/grid/:examId}
 */
export async function getApiV1ExamGridExamid(
  examId: GetApiV1ExamGridExamidPathParams["examId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamGridExamidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamGridExamid400
      | GetApiV1ExamGridExamid401
      | GetApiV1ExamGridExamid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamGridExamidUrl(examId).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
